<template>
    <aside>
        <div class="section-data" style="min-height: 400px;">
            <div class="title d-flex justify-content-between">
                <div class="text">
                    <div id="slot-title">
                    </div>
                    <h3 class="font-blue">Publicación</h3>
                    <p class="font-gray-dark">Información que se va a compartir en este curso</p>
                </div>
                <div class="tools">
                    <div id="slot-tools">
                    </div>
                </div>
            </div>
            <div class="data">
                <div class="container my-3">
                    <div id="slot-content">
                    </div>
                    <div class="content">
                        <div class="target-downloading text-center p-1 font-gray-dark" v-if="downloading">
                            <b-spinner small label="Espere ..."></b-spinner>
                            <span class="p-1">Espere un momento...</span>
                        </div>
                        <div class="target-body" v-if="!downloading">
                            <div class="row ">
                                <div class="col-md-12 col-sm-12 pt-3">
                                    <h5>Lanzamiento</h5>
                                    <div class="__info font-gray-dark text-left mb-3">
                                        El lanzamiento de los cursos es una parte fundamental para nosotros, queremos
                                        que tengas el mayor éxito posible dentro de tu carrera como capacitador.
                                    </div>


                                    <!--                </div>-->
                                    <!--                <div class="col-md-6 col-sm-12">-->
                                    <h5 class="mt-5">Términos y condiciones de uso</h5>
                                    <p class="text-left font-gray-dark">
                                        Al hacer clic en <b>Publicar Curso</b> estarás aceptando nuestros
                                        <a href="/terminos-condiciones" class="font-gray-dark font-weight-bold">
                                            Términos y condiciones de uso</a> así como también nuestro
                                        <a href="/text-center" class="font-gray-dark font-weight-bold">Aviso de privacidad</a>.
                                        <br><br>
                                        <b>
                                            El curso debe pasar por el proceso de validación
                                            kllaar.com una vez aprobado,
                                            el curso será publicado.</b>
                                    </p>
                                    <div class="__errorverification text-danger">
                                        <small>
                                            {{ publish_verification.message ? publish_verification.message : '' }}
                                        </small>
                                    </div>

                                    <b-button type="button"
                                              class="mb-5 "
                                              :class="verification ? 'b-green' : 'b-orange'"
                                              @click="sendVerification"
                                              :disabled="loading.verify || verification">
                                        <b-spinner v-show="loading.verify" small label="Espere ..."></b-spinner>
                                        <i class="fas fa-play-circle" v-show="!loading.verify"></i>
                                        {{ verification ? 'Curso Publicado' : 'Publicar Curso' }}
                                    </b-button>

                                    <hr>
                                    <h5>Eliminar Curso</h5>
                                    <div class="__info font-gray-dark">
                                        Se eliminará todo el contenido asociado a este curso. ¿Seguro de querer
                                        eliminar?.
                                    </div>
                                    <div class="__infodelete mt-3">
                                        <b-form-checkbox v-model="status" class="font-gray-dark font-weight-bold">
                                            Estoy seguro de querer eliminar este curso.
                                        </b-form-checkbox>
                                        <b-button type="button" class="text-danger btn-light mt-3"
                                                  @click="deleteCurse"
                                                  :disabled="!status">
                                            <b-spinner v-show="loading.delete"
                                                       small
                                                       label="Espere ...">
                                            </b-spinner>
                                            <i class="fas fa-trash-alt"></i> Eliminar Curso
                                        </b-button>
                                    </div>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </aside>


</template>
<script>
export default {
    data() {
        return {
            status: false,
            downloading: false,
            loading: {
                delete: false,
                verify: false
            },
            verification: false,
            publish_verification: {}
        }
    },
    methods: {
        sendVerification() {
            let id = this.$route.params.id
            this.loading.verify = true
            if (id !== undefined) {
                this.api.post('course/publish/' + id).then(({data}) => {
                    this.$bvToast.toast('Validando publicación de curso', {
                        title: "Kllaar.com",
                        variant: 'success',
                        toaster: 'b-toaster-bottom-right',
                        solid: true,
                        appendToast: true
                    })

                    this.$router.push({ name: 'perfil-cursos' })


                    this.loading.verify = false
                }).catch(err => {
                    this.loading.verify = false
                    if (err.response.status === 403) {
                        this.publish_verification = err.response.data
                    }
                    console.log(err)
                })
            }
        },
        deleteCurse() {
            let id = this.$route.params.id
            this.loading.delete = true
            if (id !== undefined) {
                this.api.delete('course/delete/' + id).then(({data}) => {
                    this.loading.delete = false
                    this.$router.push({ name: 'perfil-cursos' })
                }).catch(err => {
                    this.loading.delete = false
                    if (err.response.status === 500) {
                        this.publish_verification = err.response.data
                    }
                    console.log(err)
                })
            }
        }
    },
    created() {
        this.$nextTick(() => {
            let verify = this.$parent.curseId.published
            this.verification = verify
        })
    }
}
</script>
<style lang="scss">
.target {
  margin-top: 0;
}

.section {
  &-data {
    background: #fff !important;
    -webkit-box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    border-radius: .25rem !important;

    .title {
      padding: 15px 0 0 15px;
      border-bottom: 1px solid #EEEEEE;
    }

    .data {
      .is-empty, .is-loading {
        text-align: center;
        justify-content: center;
        align-content: center;

        img {
          opacity: .5;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/#pages/curses/pages/Publish2.vue